import axios from "../../utils/axios";

export const SET_GROUPS = "SET_GROUPS";
export const SET_GROUPS_LOADING = "SET_GROUPS_LOADING";
export const ADD_GROUP = "ADD_GROUP";
export const SET_GROUP = "SET_GROUP";

export const setGroups = (groups) => {
  return {
    type: SET_GROUPS,
    groups,
  };
};

export const setGroupsLoading = (loading) => {
  return {
    type: SET_GROUPS_LOADING,
    loading,
  };
};

export const setGroup = (group) => {
  return {
    type: SET_GROUP,
    group,
  };
};

export const addGroup = (group) => {
  return {
    type: ADD_GROUP,
    group,
  };
};

export const getGroups = () => {
  return async function (dispatch, getState) {
    dispatch(setGroupsLoading(true));
    const res = await axios.get("/api/groups");
    if (res.data && Array.isArray(res.data)) {
      dispatch(setGroups(res.data));
    }
    dispatch(setGroupsLoading(false));
  };
};

export const updateGroup = (group) => {
  return async function (dispatch, getState) {
    dispatch(setGroup(group));
    await axios.put("/api/groups/" + group.key, { group });
    dispatch(getGroups());
  };
};

export const createGroup = (group) => {
  return async function (dispatch, getState) {
    await axios.post("/api/groups", { group });
    dispatch(getGroups());
  };
};

export const deleteGroup = (key) => {
  return async function (dispatch, getState) {
    await axios.delete("/api/groups/" + key);
    dispatch(getGroups());
  };
};
